import { render } from "./Searcher.vue?vue&type=template&id=785b5a9e&scoped=true"
import script from "./Searcher.vue?vue&type=script&lang=js"
export * from "./Searcher.vue?vue&type=script&lang=js"

import "./Searcher.vue?vue&type=style&index=0&id=785b5a9e&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785b5a9e"]])

export default __exports__